import { Characteristic } from '@shared/cards-types';
import type { CardsFeatureConfig } from '@shared/cards-config';
import type { DeepPartial } from '@luna/utils-ts';

import {
    CardActivationFeatureConfig,
    CardBankHeaderFeatureConfig,
    CardLimitsChangeFeatureConfig,
    CardLimitsCombinedFeatureConfig,
    CardsSettingsCardDetailsFeatureConfig,
    CreditCardContentBoxFeatureConfig,
    CreditSharedFeatureConfig,
    DebitCardContentBoxFeatureConfig,
    InstallmentsActivationFeatureConfig,
    InstallmentsFeatureConfig,
    ReprintPinFeatureConfig,
} from './featureConfig';

export const cards: DeepPartial<CardsFeatureConfig> = {
    isNativeAliasChangeAllowed: true,
    bank: {
        showAsProduct: true,
        settings: {
            limitChange: false,
        },
        showSupplementaryCardBalance: true,
    },
    credit: CreditSharedFeatureConfig.HU,
    shared: {
        settings: {
            showMainAccountForStandalone: true,
        },
        functions: {
            tpLimits: {
                drivenByFeaturesAndFlags: true,
            },
        },
    },
    statements: {
        signed: true,
        showPhoneNumbersDropdown: false,
        reversibleToPaperDelivery: false,
        deliverySelectable: true,
    },
    components: {
        settings: {
            cardDetails: CardsSettingsCardDetailsFeatureConfig.HU,
        },
        installments: InstallmentsFeatureConfig.HU,
        installmentsActivation: InstallmentsActivationFeatureConfig.HU,
        limits: CardLimitsCombinedFeatureConfig.HU,
        limitsChange: CardLimitsChangeFeatureConfig.HU,
        cardServices: {
            reprintPin: ReprintPinFeatureConfig.HU,
        },
        bankCardHeader: CardBankHeaderFeatureConfig.HU,
        cardActivation: CardActivationFeatureConfig.HU,
        creditCardContentBox: CreditCardContentBoxFeatureConfig.HU,
        debitCardContentBox: DebitCardContentBoxFeatureConfig.HU,
    },
    navigation: {
        excludeCharacteristics: [Characteristic.AUTHORIZED],
    },
    overview: {
        CREDIT: {
            AUTHORIZED: {
                hide: true,
            },
            AUTHORIZED_STANDALONE: {
                displayLimitInfo: false,
            },
            displayLimit: true,
        },
        BANK_CARD: {
            MAIN: {
                hide: true,
            },
            AUTHORIZED: {
                hide: true,
            },
            AUTHORIZED_STANDALONE: {
                hide: true,
            },
        },
    },
};
